module.exports = __webpack_public_path__ + "static/portrait2-12135f47182d07ab1897f375b75fe86d.png";